/**
 * @generated SignedSource<<5328bb1aa8f727a58ed5a4195f808885>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ImageFinishUploadSubscription$variables = {
  id: string;
};
export type ImageFinishUploadSubscription$data = {
  readonly imageFinishedUploading: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
  } | null;
};
export type ImageFinishUploadSubscription = {
  response: ImageFinishUploadSubscription$data;
  variables: ImageFinishUploadSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "imageIds.0",
        "variableName": "id"
      }
    ],
    "kind": "ListValue",
    "name": "imageIds"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImageFinishUploadSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "imageFinishedUploading",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Image_image"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImageFinishUploadSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "imageFinishedUploading",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbhash",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageSize",
            "kind": "LinkedField",
            "name": "sizes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlExpiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "width",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae1b9a9a85f8a91136956b15b5f338c0",
    "id": null,
    "metadata": {},
    "name": "ImageFinishUploadSubscription",
    "operationKind": "subscription",
    "text": "subscription ImageFinishUploadSubscription(\n  $id: ID!\n) {\n  imageFinishedUploading(imageIds: [$id]) {\n    id\n    ...Image_image\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n"
  }
};
})();

(node as any).hash = "aec2e8f397d5d3f6b77f7e7993a5a2a0";

export default node;
